import { render, staticRenderFns } from "./AccordionSelect.vue?vue&type=template&id=63d75d20&scoped=true&"
import script from "./AccordionSelect.vue?vue&type=script&lang=ts&"
export * from "./AccordionSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionSelect.vue?vue&type=style&index=0&id=63d75d20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d75d20",
  null
  
)

export default component.exports